<script>
  import { onMount } from "svelte";
  import {replace} from 'svelte-spa-router';
  
  import Menu from './Menu.svelte';

  const urllsr = `/ianua/bin/rel`;

  let _rel = [];
  let _err = '';
  
  onMount(async () => {
    await fetch(urllsr)
      .then(r => r.json())
      .then(data => {
	_rel = data;
      });
  })
  

  /* onMount(async () => {
   *   try {
   *     const res = await fetch(urllsr);
   *     if (res.ok) {
     console.log("OK");
     json = await res.json();
   *   if (json) {
     _rel = data;
   *   }
   *     } else {
     console.log("else");
     if (res.status === 401) replace('/login');
     if (res.status === 404) throw new Error('Not found');
     throw new Error(res.status);
   *     }
   *   } catch(err) {
   *     _err = err;
   *   }
   * }); */
   
  async function postConf() {
    // verificare sia cambiato qualcosa altrimenti non fare nulla
    console.log(_rel);
    try {
      const res = await fetch(urllsr, {
	method: 'POST',
	headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(_rel),
      });
      if (res.ok) {
        _err = "Nomi aggiornati correttamente";
      } else {
	if (res.status === 401) push('/login');
        if (res.status === 404) throw new Error('Not found');
        throw new Error(res.status);
      }
    } catch(err) {
      _err = err;
    };
    
    return;
  };
  
  function reset() {
    _err = '';
    return;
  };
  
</script>

<Menu />

<div id="main" class="wrapper style1">
  <div class="container">
    <section id="content">

      <h3>Configurazione relè</h3>
      
      <form>	
	{#each _rel as r}
	  <br />
	  <div class="row gtr-uniform gtr-50">
	    <div class="col-6 col-12-xsmall">
	      <span class="text120">Nome relè {r.rela}</span>
	      <input bind:value="{r.name}" type="text" name="name" id="name+{r.rela}" placeholder="{r.name}" />
	    </div>
	    <div class="col-6 col-12-xsmall">
	      <span class="text120">Durata On/Off relè {r.rela} (ms)</span>
	      <input bind:value="{r.dela}" type="number" name="name" id="name+{r.rela}" placeholder="{r.dela}" />
	    </div>
	  </div>
	{/each}

	<br />
	
	<div class="col-12">
          <ul class="actions">
            <li><input on:click|preventDefault="{postConf}" type="submit" value="Invia" class="primary" /></li>
            <li><input on:click|preventDefault="{reset}" type="reset" value="Reset" /></li>
          </ul>
	</div>	
      </form>

      {#if _err}
        <div class="row gtr-uniform gtr-50">
          <div class="col-12 col-12-xsmall">
            <strong class="warning">{_err}</strong>
          </div>
        </div>
      {/if}
      
    </section>
  </div>
</div>
